// V9.23 · Busca rápida de fornecedor com cadastro inline
import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2, Plus, X } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export const FornecedorPicker = ({ value, valueName, onChange }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [openList, setOpenList] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (!openList) return;
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const { data } = await api.get('/fin/ledger/suppliers', { params: { q: q || undefined, limit: 20 } });
        setItems(data.items || []);
      } catch (_) { /* lista secundária */ }
    }, 250);
    return () => clearTimeout(timer.current);
  }, [q, openList]);

  const criar = async () => {
    const nome = q.trim();
    if (!nome) return;
    setBusy(true);
    try {
      const { data } = await api.post('/fin/ledger/suppliers', { nome });
      onChange(data.supplier.id, data.supplier.nome);
      setOpenList(false);
      setQ('');
      toast.success('Fornecedor cadastrado e selecionado.');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Erro ao cadastrar fornecedor.');
    } finally { setBusy(false); }
  };

  if (value) {
    return (
      <div className="flex items-center gap-2" data-testid="fornecedor-selecionado">
        <span className="flex-1 text-sm border rounded px-3 py-2 bg-muted/40 truncate">{valueName}</span>
        <Button type="button" size="sm" variant="ghost" onClick={() => onChange(null, null)}
          data-testid="fornecedor-limpar"><X className="w-4 h-4" /></Button>
      </div>
    );
  }

  return (
    <div className="relative">
      <Input value={q} placeholder="Buscar fornecedor por nome ou CNPJ…"
        onFocus={() => setOpenList(true)}
        onChange={(e) => { setQ(e.target.value); setOpenList(true); }}
        data-testid="fornecedor-busca" />
      {openList && (
        <div className="absolute z-50 mt-1 w-full max-h-56 overflow-y-auto rounded-md border bg-popover shadow-lg">
          {items.map((f) => (
            <button key={f.id} type="button" data-testid={`fornecedor-opt-${f.id}`}
              className="w-full text-left px-3 py-2 text-sm hover:bg-accent"
              onClick={() => { onChange(f.id, f.nome); setOpenList(false); setQ(''); }}>
              {f.nome}{f.documento ? ` · ${f.documento}` : ''}
            </button>
          ))}
          {q.trim() && !items.some((f) => f.nome.toLowerCase() === q.trim().toLowerCase()) && (
            <button type="button" onClick={criar} disabled={busy} data-testid="fornecedor-criar"
              className="w-full text-left px-3 py-2 text-sm font-medium text-primary hover:bg-accent flex items-center gap-1">
              {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Plus className="w-3 h-3" />}
              Cadastrar "{q.trim()}"
            </button>
          )}
          {!items.length && !q.trim() && (
            <p className="px-3 py-2 text-xs text-muted-foreground">Digite para buscar…</p>
          )}
        </div>
      )}
    </div>
  );
};

export default FornecedorPicker;
